import { BIGLogicNotificationKind } from "src/model/enum/enumNotifications";

export class AddressesForward {
    public id: number = 0;
    public description: string = "";
    public sourceAddress: string = "";
    public nameSourceAddress: string = "";
    public instanceGUIDSourceAddress: string = "";
    public destinationAddress: string = "";
    public nameDestinationAddress: string = "";
    public instanceGUIDDestinationAddress: string = "";
    public active: boolean = false;
    public idLogic: number = 0;
    public logicDescription: string = "";
    public factor: number = 1;
    public offset: number = 0;
    public minAllowedValue: number = -9999;
    public maxAllowedValue: number = 9999;
    public fixedValue: string = "";
    public sendValueOnChange: BIGLogicNotificationKind = BIGLogicNotificationKind.Always;
}
